module.exports = __webpack_public_path__ + "media/images/upload-image-1fc530741df2052b145e5fbd8aca13a2.png";